import { FC } from 'react'

import { BankData } from '@/screens/Credit/page/types'
import ConditionsItem from '@/screens/Credit/page/ui/CreditConditionsBlock/ConditionsItem/ConditionsItem'

import cl from './ConditionsList.module.scss'

const ConditionsList: FC<{ data: BankData[] }> = ({ data }) => {
	return (
		<ul className={cl.conditions__list}>
			{data.map((item, index) => (
				<ConditionsItem item={item} key={index} />
			))}
		</ul>
	)
}

export default ConditionsList
